var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"indexinner"}},[_c('banner',{attrs:{"carouselArr":_vm.bannerlist,"Recommendlist2":_vm.Recommendlist2}}),_c('advertisement'),_c('indexshoplist'),_c('indexnews')],1)}
var staticRenderFns = []

export { render, staticRenderFns }